import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'preferences-1',
  templateUrl: './preference_1.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryPreference1Component implements OnInit {
  @Input() data;
  @Output() continuePreference1Emitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}

  continue(next_step: string) {
    this.continuePreference1Emitter.emit({ status: next_step, id: this.data.id });
  }

  back() {
    this.continuePreference1Emitter.emit({ status: 'backward' });
  }
}
